import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'react-hot-toast';
import App from './App';
import { AppProvider } from './context/AppContext';
import { CartProvider } from './context/CartContext';
import { AuthProvider } from './context/AuthContext';
import './i18n/i18n';
import './styles/tokens.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/index.css';
import './components/ui/SkeletonLoader.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

// Enhanced Google Analytics initialization for SPA
const initializeGoogleAnalytics = () => {
  // Ensure gtag is available
  if (typeof window !== 'undefined' && window.gtag) {
    // Additional verification tracking
    window.gtag('event', 'app_initialized', {
      app_name: 'Pizza Inn Baku',
      debug_mode: process.env.NODE_ENV === 'development',
      spa_version: 'React 18',
      timestamp: new Date().toISOString()
    });
    
    // Set user properties for better tracking
    window.gtag('config', 'G-FQWNYFDSCV', {
      custom_map: {
        dimension1: 'language',
        dimension2: 'user_type'
      },
      page_title: document.title,
      page_location: window.location.href
    });
    
    console.log('✅ Google Analytics initialized successfully');
  } else {
    console.warn('⚠️ Google Analytics not loaded');
  }
};

// Initialize after DOM is ready
if (typeof window !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeGoogleAnalytics);
  } else {
    initializeGoogleAnalytics();
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true
      }}
    >
      <HelmetProvider>
        <AppProvider>
          <AuthProvider>
            <CartProvider>
              <App />
              <Toaster 
                position="top-right"
                toastOptions={{
                  duration: 4000,
                  style: {
                    background: '#333',
                    color: '#fff',
                    fontFamily: 'var(--font-ui)',
                  },
                  success: {
                    iconTheme: {
                      primary: '#10B981',
                      secondary: '#fff',
                    },
                  },
                  error: {
                    iconTheme: {
                      primary: '#EF4444',
                      secondary: '#fff',
                    },
                  },
                }}
              />
            </CartProvider>
          </AuthProvider>
        </AppProvider>
      </HelmetProvider>
    </BrowserRouter>
  </React.StrictMode>
);
